import { DailyStep } from "../../types/DailyStep";
import DB_PATH from "../DB_PATH";
import firebase from "../firebase";

export default async ({ dailyStep }: { dailyStep: DailyStep }) => {
  try {
    const firestore = firebase.firestore();
    const collectionRef = firestore.collection(DB_PATH.PLAN_STEP);

    // Generate an ID if one is missing or empty
    const stepRef =
      dailyStep.id && dailyStep.id.trim().length > 0
        ? collectionRef.doc(dailyStep.id)
        : collectionRef.doc();
    const stepId = dailyStep.id && dailyStep.id.trim().length > 0 ? dailyStep.id : stepRef.id;

    const stepData = { ...dailyStep, id: stepId };
    console.log("Created daily Step", stepData);

    await stepRef.set(stepData);
  } catch (error) {
    console.error("Error creating daily step:", error);
  }
};
